<template>
  <div class="c-favorite">
    <h1 class="c-favorite--heading">
      <img :src="require('@/assets/images/icon-favourite.png')">
      お気に入り物件リスト
    </h1>
    <loading v-if="!isReady"/>
    <div v-else>
      <p class="c-favorite--count">{{count}}件</p>
      <ul v-if="count > 0" class="c-favorite--list">
        <li class="c-favorite--list--item" v-for="(item, index) in list" :key="index">
          <common-property-card class="c-favorite--list--item__card" :propdata="item" />
          <div class="c-favorite--list--item__block">
            <div class="c-favorite--list--item__block__button">
              <common-button
                class="u-mB10"
                :title="'この物件に問い合わせる'"
                :type="'link'"
                :link_url="`/reservation/${item.id}`"
                :large="true"
                :width="'248px'"
                :border_red_text_black="true"
                :font_size="'14px'"
                :icon="'icon-mail'" />
              <common-button
                class="u-mB10"
                :title="'掲載元のページに移動'"
                :type="'link'"
                :link_url="item.url"
                :large="true"
                :width="'248px'"
                :border_red_text_black="true"
                :font_size="'14px'"
                :icon="'icon-external-link'" />
              <common-button
                class="u-mB10"
                :title="'詳細を見る'"
                :type="'link'"
                :link_url="`/kodate/${item.id}`"
                :large="true"
                :width="'248px'"
                :border_red_text_black="true"
                :font_size="'14px'"
                :icon="'icon-detail'" />
            </div>
            <span class="c-favorite--list--item__block__media">{{isValued(item.media)}}</span>
            <span class="c-favorite--list--item__block__delete" @click="deleteItem(item.id)"><img :src="require('@/assets/icon-trash-can.png')">削除する</span>
            <span class="c-favorite--list--item__block__provided">情報提供日：{{isDateFormated(item.provided_at)}}</span>
            <span class="c-favorite--list--item__block__update">次回更新日：{{isValued(item.modify_at)}}</span>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="count <= 0" class="c-favorite--noprops">お気に入りした物件の登録はありません。</div>
  </div>
</template>

<script>
import axios from 'axios';
import MixinUtil from '@/plugins/mixin-utils';
import IsMobileMixin from '@/plugins/isMobile';
import MixinAPI from '@/plugins/mixin-api';
import MixinMeta from '@/plugins/mixin-meta';
import CommonPropertyCard from '@/components/parts/CommonPropertyCard';
import CommonButton from '@/components/parts/button/CommonButton';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import Loading from '@/components/common/Loading';

export default {
  name: 'FavoriteContents',
  mixins: [MixinUtil, IsMobileMixin, BehaviorLogMixin, MixinAPI, MixinMeta],
  components: {
    CommonPropertyCard,
    CommonButton,
    Loading,
  },
  data() {
    return {
      list: [],
      propdata: [],
      isReady: false,
    };
  },
  computed: {
    storedFavorite() {
      return this.$store.getters['getFavorite'].data;
    },
    count() {
      return this.list.length;
    },
  },
  async created() {
    this.metaSetForDefault('bookmark');
    if (this.favoriteMetaList === null) this.list = [];
    const favoriteMetaList = this.storedFavorite || [];
    const fetchPromises = favoriteMetaList.map(a =>
      new Promise(async (resolve) => {
        const details = await this.getPropertyData(a.id);
        resolve(details.data);
      }),
    );
    this.list = await Promise.all(fetchPromises);
    this.isReady = true;
  },
  methods: {
    deleteItem(id) {
      this.deleteWishList(id);
      this.list = this.list.filter(a => a.id !== id);
    },
    async filteredList() {
      let url;
      if (process.env.VUE_APP_ENV === 'prod') {
        url = 'https://prod-api.yeah.ki-group.jp/real-estate-properties/';
      } else {
        url = 'https://stg-api.yeah.ki-group.jp/real-estate-properties/';
      }
      return this.list.filter(async (n) => {
        const id = await axios(`${url}${n.id}`).then(r => r);
        return (id.results === 'success');
      });
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

.c-favorite {
  background-color: #FAFAFA;
  position: relative;
  &--heading {
    width:100%;
    text-align: center;
    font-size:20px;
    font-weight: bold;
    padding-top:40px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  &--count {
    width:100%;
    text-align: center;
    margin-top:30px;
    font-size:20px;
    font-weight: bold;
  }
  &--noprops {
    height:calc(100vh - 365px);
    width: 100%;
    display:flex;
    justify-content: center;
    align-items: center;
  }
  &--list {
    margin: 30px auto;
    width: 720px;
    &--item {
      width: 720px;
      // height: 320px;
      padding:20px;
      display:flex;
      justify-content: space-between;
      margin-bottom:20px;
      background-color:#FFF;
      border: 1px solid #CCC;
      border-radius:15px;
      &__card {
        width:346px;
      }
      &__block {
        width: 315px;
        position:relative;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          position:absolute;
        }
        &__media {
          font-size: 16px;
          top:0;
          left:0;
        }
        &__delete {
          font-size:14px;
          top:0;
          right:0;
          cursor: pointer;
          img {
            width:24px;
            height:24px;
            vertical-align: middle;
          }
        }
        &__provided {
          font-size:12px;
          bottom:18px;
          right:0;
        }
        &__update {
          font-size:12px;
          bottom:0;
          right:0;

        }
      }
    }
  }
}

.u-mB10 {
  margin-bottom: 10px;
}

@media screen and (max-width: 767px)  {

.c-favorite {
  background-color: #FAFAFA;
  position: relative;
  &--heading {
    position: absolute;
    top: 20px;
    width: 255px;
    z-index: 100;
    left: 0;
    margin: 0;
    padding: 0;
  }
  &--count {
    position: absolute;
    right: 10px;
    top: 23px;
    z-index: 100;
    text-align: right;
    margin: 0;
  }
  &--list {
    margin: auto;
    width: 100%;
    padding: 64px 0 00px;
    max-width: 960px;
    &--item {
      flex-wrap:wrap;
      width: 100%;
      margin: auto;
      padding: 0;
      margin-bottom: 20px;
      background:0;
      border: 0;
      &__card {
        display: flex;
        justify-content: center;
        width: 100%;
      }
      &__block {
        width: 346px;
        margin: 10px auto;
        border-bottom: 1px dashed #CCC;
        &__button {
          margin:40px;
        }

        &__provided {
          bottom:24px;
        }
        &__update {
          bottom:6px;
        }
      }
    }
  }
}

}

</style>
